"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalThisShim = void 0;
exports.globalThisShim = (() => {
    if (typeof self !== "undefined") {
        return self;
    }
    else if (typeof window !== "undefined") {
        return window;
    }
    else {
        return Function("return this")();
    }
})();



//////////////////
// WEBPACK FOOTER
// ./~/engine.io-client/build/cjs/globalThis.browser.js
// module id = 103
// module chunks = 0